module.exports = __webpack_public_path__ + "img/Certificate.06dfbe56.jpg";